import { Footer } from "@/Components/Footer";
import { LatestResultsCard } from "@/Components/LatestResultsCard";
import Navigation from "@/Components/Navigation";
import { isNoUOrEmptyString } from "@/lib/utils";
import type { UnauthenticatedPageProps } from "@/types";
import { diffWeeks } from "@formkit/tempo";
import { type PropsWithChildren, useMemo } from "react";
import { Toaster } from "react-hot-toast";

type UnauthenticatedLayoutProps = PropsWithChildren & {
	title?: string;
};

export default function UnauthenticatedLayout({
	title,
	children,
	app,
}: UnauthenticatedPageProps<UnauthenticatedLayoutProps>) {
	const results = useMemo(() => {
		return app.sharedData.matches.filter(
			(match) =>
				!isNoUOrEmptyString(match.score) &&
				!isNoUOrEmptyString(match.date) &&
				diffWeeks(new Date(), new Date(match.date ?? 0)) < 1,
		);
	}, [app.sharedData.matches]);

	return (
		<>
			<Toaster />
			<div className="flex flex-col gap-2 mx-2 pb-12">
				<Navigation type="public" isRegistrationOpen={app.isRegistrationOpen} />
				<LatestResultsCard matches={results} />
				{title && (
					<h1 className="text-2xl font-bold mx-auto my-4 uppercase">{title}</h1>
				)}
				{children}
			</div>
			<Footer />
		</>
	);
}
